import { render } from "./Framework.vue?vue&type=template&id=559bfc5e&scoped=true"
import script from "./Framework.vue?vue&type=script&lang=js"
export * from "./Framework.vue?vue&type=script&lang=js"

import "./Framework.vue?vue&type=style&index=0&id=559bfc5e&scoped=true&lang=css"

import exportComponent from "E:\\changjuCode\\official-web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-559bfc5e"]])

export default __exports__